import React from "react";

import { IconButton, Stack, Typography } from "@mui/material";
import Modal from "@mui/material/Modal";
import { Nullable } from "store/types";
import { BaseModal } from "store/types/modals";

import { ReactComponent as CrossIcon } from "../../../assets/icons/cross.svg";
import { ReactComponent as TickIcon } from "../../../assets/icons/tick.svg";
import { useModals } from "../../../hooks";

interface Props {
  data: Nullable<BaseModal>;
}

export const SuccessModal: React.FC<Props> = ({ data }) => {
  const { closeSuccessModal } = useModals();

  return (
    <Modal open={!!data} onClose={closeSuccessModal}>
      <Stack
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          outline: "none",
          width: "520px",
          borderRadius: "5px",
          overflow: "hidden",
          bgcolor: "white"
        }}
      >
        <Stack
          sx={{
            position: "relative",
            height: "116px",
            backgroundColor: "#26a6ae",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Stack
            sx={{
              boxSizing: "content-box",
              border: "3px solid white",
              borderRadius: "50%",
              padding: "15px",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <TickIcon width="36px" height="36px" fill="white" />
          </Stack>
          <IconButton
            onClick={closeSuccessModal}
            sx={{
              position: "absolute",
              top: "15px",
              right: "15px",
              color: "white",
              "&:hover": {
                backgroundColor: "rgba(255, 255, 255, 0.1)"
              }
            }}
          >
            <CrossIcon />
          </IconButton>
        </Stack>
        <Stack
          sx={{
            minHeight: "138px",
            maxHeight: "250px",
            overflowX: "auto",
            backgroundColor: "white",
            color: "#26a6ae",
            padding: "20px 40px",
            textAlign: "center",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Typography
            sx={{
              fontSize: "24px",
              lineHeight: "40px",
              fontWeight: 400,
              color: "#0a3142"
            }}
          >
            {data?.msg}
          </Typography>
        </Stack>
      </Stack>
    </Modal>
  );
};
